import React from 'react';

const ErrorMessage = ({ errorMessage }) => {
  if (!errorMessage) {
    return null;
  } else {
    return (
      <div className="alert alert-danger" role="alert">
        {errorMessage}
      </div>
    );
  }
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/shared/ErrorMessage.js